export default __webpack_public_path__ + "static/media/1977.39e78878.png";